import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import maison from '../assets/images/maison.svg';
import {Partenaires} from "./Home/Partenaires";
import RubriqueSevice from "../service/RubriqueSevice";
import {urlBase} from "../config/Globals";

export const PageToutSavoir = () => {
    const titrePage = "Tout savoir sur la flavescence dorée";
    const[rubriques, setRubriques] = useState([]);
    const[loadingRubriques, setLoadingRubriques] = useState(1);
    const fetchRubriques = async() => {
        try{
            const data = await RubriqueSevice.findAll();
            setRubriques(data);
            setLoadingRubriques(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchRubriques();
    }, []);
    return (
        <>
            <Helmet>
                <title>{titrePage}</title>
                <meta name="description" content={titrePage} />
            </Helmet>
            <main class="type">
                <section className="pb-5">
                    <div className="bg-cover"></div>
                    <div className="container px-4 pb-5 position-relative z-1">
                        <div className="row justify-content-center text-center pt-lg-4 pb-lg-5 position-relative z-1">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb justify-content-center">
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase} className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator text-white">•</li>
                                        <li className="breadcrumb-item-custom  text-white active" aria-current="page">
                                            {titrePage}
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12">
                                <h1 className="text-white display-5 fw-sb mb-3">{titrePage}</h1>
                            </div>
                        </div>
                        <div className="row flex-column align-items-center g-4 justify-content-center">
                            {
                                rubriques.map((rubrique, index) => (
                                    <div key={rubrique.id} className="col-12 col-lg-5">
                                        <div className="bg-white rounded-2 col-12 p-4 p-md-5 d-flex flex-column align-items-center text-center">
                                            <h2 className="h4 fw-sb">{rubrique.titre}</h2>
                                            <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree/' + rubrique.wording} className="btn btn-warning mt-4">En savoir plus</a>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </section>
               <Partenaires />
            </main>
        </>
    );
}